import { FC } from 'react';
import {
  Button,
  FormControl,
  FormLabel,
  Input,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  Stack,
  Text,
} from '@chakra-ui/react';
import { MenuCategoryRegistrationFormFields } from '../../../types/menuCategoryRegistrationFormFields';

type Props = {
  values: MenuCategoryRegistrationFormFields;
  handleClose: () => void;
};

export const MenuRegistrationResultModalView: FC<Props> = ({
  values,
  handleClose,
}) => (
  <ModalContent maxHeight="90vh">
    <ModalHeader p="40px">メニューの登録</ModalHeader>
    <ModalCloseButton />
    <ModalBody overflowY="auto" px="40px">
      <Stack spacing="6" direction="column">
        <FormControl>
          <FormLabel>メニューID</FormLabel>
          <Input
            type="text"
            value={values.id}
            width="240px"
            variant="flushed"
            isReadOnly
            isTruncated
          />
        </FormControl>
        <FormControl>
          <FormLabel>メニュー名</FormLabel>
          <Input
            type="text"
            value={values.name}
            variant="flushed"
            isReadOnly
            isTruncated
          />
        </FormControl>
      </Stack>
      <Text align="center" fontWeight="bold" mt="60px">
        登録が完了しました
      </Text>
    </ModalBody>
    <ModalFooter justifyContent="center" mx="20px" gap="16px" p="40px">
      <Button
        w="140px"
        colorScheme="blackAlpha"
        variant="outline"
        onClick={handleClose}
      >
        閉じる
      </Button>
    </ModalFooter>
  </ModalContent>
);
